import {Component, inject, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AdminService} from '../../admin/services/admin.services';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {updateSeo} from '../../shared/seo/seo';

@Component({
  selector: 'app-login',
  imports: [
    FormsModule
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit {
public username!: string;
public password!: string;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  adminService = inject(AdminService);
  router = inject(Router);
  private readonly document = inject(DOCUMENT);

  ngOnInit() {
    updateSeo(
      this.document,
      'Login | VENTORA Admin',
      'Secure admin login for the VENTORA store.',
      undefined,
      '/login',
      undefined,
      'noindex,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
    );
  }

  login() {
    if (!this.username || !this.password) {
      this.errorMessage = 'Please enter username and password';
      return;
    }

    this.adminService.login(this.username, this.password).subscribe({
      next: (res) => {
        this.successMessage = res.state;
        this.errorMessage = null;
        localStorage.setItem('state', res?.state)
        if(res?.state === '$2a$12$yT69u8ypn7hMRuBLhLrju.9K.oKv0dYQWSbES4LCEOi5VaWt3r5D'){
          this.router.navigateByUrl('/admin/home');
        }
        console.log('Login success:', res);
      },
      error: (err) => {
        this.errorMessage = err.error?.message || 'Login failed';
        this.successMessage = null;
        console.error('Login error:', err);
      },
    });
  }
}
